// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "Streaming.proto" (package "streaming", syntax proto3)
// tslint:disable
import { ConfirmStreamingEventsService } from "./Streaming";
import type { ConfirmRequest } from "./Streaming";
import { UpdateConnectionStateService } from "./Streaming";
import type { Empty } from "./google/protobuf/empty";
import type { UpdateStateRequest } from "./Streaming";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { OpenStreamingConnectionService } from "./Streaming";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { GrpcEvent } from "./Streaming";
import type { ConnectRequest } from "./Streaming";
import type { ServerStreamingCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service streaming.OpenStreamingConnectionService
 */
export interface IOpenStreamingConnectionServiceClient {
    /**
     * Setup a new connection to receive events
     *
     * @generated from protobuf rpc: connect(streaming.ConnectRequest) returns (stream streaming.GrpcEvent);
     */
    connect(input: ConnectRequest, options?: RpcOptions): ServerStreamingCall<ConnectRequest, GrpcEvent>;
}
/**
 * @generated from protobuf service streaming.OpenStreamingConnectionService
 */
export class OpenStreamingConnectionServiceClient implements IOpenStreamingConnectionServiceClient, ServiceInfo {
    typeName = OpenStreamingConnectionService.typeName;
    methods = OpenStreamingConnectionService.methods;
    options = OpenStreamingConnectionService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Setup a new connection to receive events
     *
     * @generated from protobuf rpc: connect(streaming.ConnectRequest) returns (stream streaming.GrpcEvent);
     */
    connect(input: ConnectRequest, options?: RpcOptions): ServerStreamingCall<ConnectRequest, GrpcEvent> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConnectRequest, GrpcEvent>("serverStreaming", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service streaming.UpdateConnectionStateService
 */
export interface IUpdateConnectionStateServiceClient {
    /**
     * Update the connection state
     *
     * @generated from protobuf rpc: update(streaming.UpdateStateRequest) returns (google.protobuf.Empty);
     */
    update(input: UpdateStateRequest, options?: RpcOptions): UnaryCall<UpdateStateRequest, Empty>;
}
/**
 * @generated from protobuf service streaming.UpdateConnectionStateService
 */
export class UpdateConnectionStateServiceClient implements IUpdateConnectionStateServiceClient, ServiceInfo {
    typeName = UpdateConnectionStateService.typeName;
    methods = UpdateConnectionStateService.methods;
    options = UpdateConnectionStateService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Update the connection state
     *
     * @generated from protobuf rpc: update(streaming.UpdateStateRequest) returns (google.protobuf.Empty);
     */
    update(input: UpdateStateRequest, options?: RpcOptions): UnaryCall<UpdateStateRequest, Empty> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<UpdateStateRequest, Empty>("unary", this._transport, method, opt, input);
    }
}
/**
 * @generated from protobuf service streaming.ConfirmStreamingEventsService
 */
export interface IConfirmStreamingEventsServiceClient {
    /**
     * Confirm received events
     *
     * @generated from protobuf rpc: confirm(streaming.ConfirmRequest) returns (google.protobuf.Empty);
     */
    confirm(input: ConfirmRequest, options?: RpcOptions): UnaryCall<ConfirmRequest, Empty>;
}
/**
 * @generated from protobuf service streaming.ConfirmStreamingEventsService
 */
export class ConfirmStreamingEventsServiceClient implements IConfirmStreamingEventsServiceClient, ServiceInfo {
    typeName = ConfirmStreamingEventsService.typeName;
    methods = ConfirmStreamingEventsService.methods;
    options = ConfirmStreamingEventsService.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * Confirm received events
     *
     * @generated from protobuf rpc: confirm(streaming.ConfirmRequest) returns (google.protobuf.Empty);
     */
    confirm(input: ConfirmRequest, options?: RpcOptions): UnaryCall<ConfirmRequest, Empty> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<ConfirmRequest, Empty>("unary", this._transport, method, opt, input);
    }
}
